var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFilled = function SvgCloseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m4.764 6.236a.807.807 0 0 0-1.141 0L12 10.86 8.377 7.236a.807.807 0 0 0-1.14 1.141L10.858 12l-3.623 3.623a.807.807 0 0 0 1.141 1.14L12 13.142l3.623 3.623a.807.807 0 0 0 1.14-1.141L13.142 12l3.623-3.623a.807.807 0 0 0 0-1.14",
    clipRule: "evenodd"
  })));
};
export default SvgCloseFilled;